var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-form",
            {
              ref: "formSearch",
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    on: { change: _vm.changeTimeType },
                                    model: {
                                      value: _vm.queryForm.params.timeDimension,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "timeDimension",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.timeDimension",
                                    },
                                  },
                                  _vm._l(
                                    _vm.timeTypeList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "picker-options": _vm.pickerOptions,
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.queryDateTime,
                              callback: function ($$v) {
                                _vm.queryDateTime = $$v
                              },
                              expression: "queryDateTime",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("tablePrice.region") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.stateOrSite,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "stateOrSite",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.stateOrSite",
                              },
                            },
                            _vm._l(_vm.regionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.zhName + "（" + item.puName + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.state") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.regionOrState,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "regionOrState",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.regionOrState",
                              },
                            },
                            _vm._l(_vm.stateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("tablePrice.complaintType") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.complaintSource,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "complaintSource",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.complaintSource",
                              },
                            },
                            _vm._l(_vm.complaintSourceList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.processingResult"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.processingResult,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "processingResult",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.processingResult",
                              },
                            },
                            _vm._l(_vm.complaintTypeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-search",
                              size: "small",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.btnSearch(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-refresh-left",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.btnSearch(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("operationCenter.reset")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.allExportOrder },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { color: "black" },
            "span-method": _vm.objectSpanMethod,
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tablePrice.region"),
              align: "center",
              "min-width": "120",
              prop: "regionOrStateName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.state"),
              "min-width": "120",
              prop: "stateOrSite",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tablePrice.monthToDate"),
              "min-width": "120",
              prop: "currentMonthFalseSignCount",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tablePrice.dailyAverage"),
              "min-width": "120",
              prop: "avgOfSearchDay",
            },
          }),
          _c(
            "el-table-column",
            { attrs: { label: _vm.$t("GlobalSetObj.sum"), align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.falseDeliveryCount"),
                  "min-width": "150",
                  prop: "falseSignCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.deliveryCount"),
                  "min-width": "150",
                  prop: "signedCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.falseDeliveryRate"),
                  "min-width": "150",
                  prop: "signRate",
                },
              }),
            ],
            1
          ),
          _vm._l(_vm.columnList, function (item) {
            return _c(
              "el-table-column",
              { key: item.id, attrs: { label: item.label, align: "center" } },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("tablePrice.falseDeliveryCount"),
                    prop: item.falseSignCount,
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("tablePrice.deliveryCount"),
                    prop: item.signedCount,
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("tablePrice.falseDeliveryRate"),
                    prop: item.signRate,
                    "min-width": "150",
                  },
                }),
              ],
              1
            )
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tablePrice.dayOverDay"),
              align: "center",
              "min-width": "120",
              prop: "dailyComparison",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        style: {
                          color: scope.row.dailyComparisonStyle
                            ? "#009c37"
                            : "red",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(scope.row.dailyComparison || "--") + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tablePrice.weekOverWeek"),
              align: "center",
              "min-width": "120",
              prop: "weeklyComparison",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        style: {
                          color: scope.row.weeklyComparisonStyle
                            ? "#009c37"
                            : "red",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(scope.row.weeklyComparison || "--") + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tablePrice.monthOverMonth"),
              align: "center",
              "min-width": "120",
              prop: "monthlyComparison",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        style: {
                          color: scope.row.monthlyComparisonStyle
                            ? "#009c37"
                            : "red",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.monthlyComparison || "--") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.getCurrentTableData,
              "size-change": _vm.getSizeTableData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }